<template>
  <div
    v-update-cell-height
    class="main"
    :class="{ self: message.self}"
  >
    <p class="time">
      <span>{{ message.date | time }}</span>
    </p>
    <img
      class="avatar"
      width="36"
      height="36"
      :src="message.self ? selfAvatar : contactAvatar"
    >
    <div
      v-if="message"
      :class="{ self: message.self}"
    >
      <div
        v-if="message.body"
        class="text"
      >
        {{ message.body }}
      </div>
      <div
        v-if="message.hasMedia"
      >
        <div
          v-for="(item, i) in mediaList(msgIndex)"
          :key="i"
        >
          <VImg
            v-if="isImage(item)"
            :position="imagePosition"
            :src="getTwilioMediaUrl(item.uri)"
            :lazy-src="require('@/assets/import-placeholder.png')"
            max-width="300px"
            max-height="600px"
            aspect-ratio="1.0"
            contain
            @click.prevent="onImgClicked(getTwilioMediaUrl(item.uri), message.body)"
          >
            <VLayout
              slot="placeholder"
              fill-height
              align-center
              justify-center
              ma-0
            >
              <VProgressCircular
                indeterminate
                color="grey lighten-5"
              />
            </VLayout>
          </VImg>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import { twilioAxios } from '@/backend/vue-axios'
export default {
  name: 'MessageCell',
  directives: {
    'update-cell-height': {
      inserted: function (el, binding, vnode) {
        const self = vnode.context
        const message = self.message
        const index = self.msgIndex
        const key = 'height'
        const val = el.clientHeight
        self.$store.dispatch('message/updateMessage', { message, index, key, val })
      }
    }
  },
  filters: {
    time (date) {
      if (!date) { return '' }
      if (typeof date === 'string') {
        date = new Date(date)
      }
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const day = ('0' + date.getDate()).slice(-2)
      const year = date.getFullYear()
      const hours = ('0' + date.getHours()).slice(-2)
      const minutes = ('0' + date.getMinutes()).slice(-2)
      return `${month}/${day}/${year} ${hours}:${minutes}`
    }
  },
  props: {
    message: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  computed: {
    ...mapGetters({
      allMessages: 'message/getAllMessages',
      mediaList: 'message/getMediaListByIndex',
      selfAvatar: 'message/getSelfAvatar',
      contactAvatar: 'messageDrawer/getContactAvatar'
    }),
    msgIndex () {
      return this.allMessages.indexOf(this.message)
    },
    imagePosition () {
      return _.get(this.message, 'self', true) ? 'right' : 'left'
    }
  },
  methods: {
    getTwilioMediaUrl (mediaUri) {
      this.$emit('loadImage')
      return twilioAxios.defaults.baseURL + mediaUri.substring(0, mediaUri.lastIndexOf('.'))
    },
    isImage (item) {
      return item.content_type.includes('image')
    },
    onImgClicked (imgUrl, imgTitle) {
      this.$emit('imgClicked', { imgUrl, imgTitle })
    }
  }
}
</script>

<style lang="less" scoped>
  .time {
    margin: 7px 7px;
    text-align: center;
    > span {
      display: inline-block;
      padding: 0 18px;
      font-size: 12px;
      color: #fff;
      border-radius: 2px;
      background-color: #dcdcdc;
    }
  }
  .avatar {
    float: left;
    margin: 0 10px 0 0;
    border-radius: 50%;
  }
  .text {
    display: inline-block;
    position: relative;
    padding: 0 10px;
    max-width: ~'calc(100% - 46px)';
    min-height: 36px;
    line-height: 2.5;
    font-size: 12px;
    text-align: left;
    word-break: break-word;
    background-color: #fafafa;
    border-radius: 4px;
    margin-bottom: 6px;

  &:before {
     content: " ";
     position: absolute;
     top: 9px;
     right: 100%;
     border: 6px solid transparent;
     border-right-color: #fafafa;
   }
  }
  .self {
    text-align: right;
    .avatar {
      float: right;
      margin: 0 0 0 10px;
    }
    .text {
      background-color: #b2e281;
      &:before {
        right: inherit;
        left: 100%;
        border-right-color: transparent;
        border-left-color: #b2e281;
      }
    }
  }

</style>
